:root {
  --side-panel--menu-width: 380px;
  --side-panel--header-height: 60px;
  --side-panel--header-padding: var(--spacer-5, 20px);
  --side-panel--content-padding: var(--spacer-5, 20px);
}

.sidePanel {
  align-self: stretch;
  position: relative;
  z-index: 101;
  transition: box-shadow 0.3s ease;
  pointer-events: none;
  margin-left: -40px;
  border-bottom: 1px solid var(--theme-light-border);
}

.sidePanelHeaderBack {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: var(--side-panel--header-height);
  padding: 0 var(--side-panel--header-padding);
  font-size: 14px;
  color: var(--theme-primary-text);
  opacity: 1;
  transition: opacity 0.2s ease;
}

.sidePanelHeaderBackHidden {
  opacity: 0;
}

.sidePanelSlider {
  position: absolute;
  top: var(--side-panel--header-height);
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  transition: left 0.3s ease;
}

.sidePanelSliderTransitionDisabled,
aha-sidepanel[data-resizing] .sidePanelSlider {
  transition: none;
}

.sidePanelSlideItem {
  position: relative;
  flex: 0 0 var(--side-panel--menu-width);
  max-width: var(--side-panel--menu-width);
  height: 100%;
}

.sidePanelSlideItemInner {
  display: none;
  flex-direction: column;
  height: 100%;
}

.sidePanelSlideItemInnerActive {
  display: flex;
}

.sidePanelHeader,
:global(.side-panel__header) {
  min-height: 60px;
  border-bottom: 1px solid var(--theme-light-border);
  padding: var(--spacer-2) var(--side-panel--content-padding) 0
    var(--side-panel--header-padding);
}

.sidePanelTitle,
:global(.side-panel__title) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
}

.sidePanelTitleText,
:global(.side-panel__title-text) {
  font-weight: 600;
  color: var(--theme-primary-text);
}

.sidePanelMetaText,
:global(.side-panel__meta-text) {
  color: var(--theme-accent-text);
}

.sidePanelTitleComponent {
  display: flex;
  justify-content: flex-end;
}

.sidePanelSliderDepth1 .sidePanelTitle,
.sidePanelSliderDepth1 :global(.side-panel__title) {
  border-bottom: 0;
}

.sidePanelItems {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.sidePanelItem {
  padding: 0 var(--side-panel--header-padding);
  margin: 0;
}

.sidePanelItemButton {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  font-size: 16px;
  border: 0;
  background: none;
  border-bottom: 1px solid var(--theme-light-border);
  cursor: pointer;
  padding: calc(var(--spacer-3) * 1.2) var(--spacer-3);
  border-radius: var(--Common--border-radius);
  color: var(--theme-secondary-text);
}
.sidePanelItemButton:hover {
  background: var(--theme-container-light-background);
  color: var(--theme-primary-text);
}
.sidePanelItemButton:hover .sidePanelItemChevron {
  color: var(--theme-primary-text);
}

.sidePanelItem:last-child .sidePanelItemButton {
	border: 0;
}

.sidePanelItemIcon {
  display: flex;
  text-align: left;
  width: 32px;
  height: 17px;
}

.sidePanelItemName {
  display: flex;
  font-size: 14px;
}

.sidePanelItemChevron {
  margin-left: auto;
  font-size: 12px;
  color: var(--theme-tertiary-text);
}

.sidePanelContent,
:global(.side-panel__content) {
  padding: var(--spacer-5) var(--side-panel--content-padding);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: auto;
  height: 100%;
  overscroll-behavior: contain;
}

:global(.side-panel__list) {
  margin-left: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacer-1);

  > li {
    list-style: none;
  }

  > li {
    &:not(:last-child) {
      padding-bottom: var(--spacer-1);
      border-bottom: 1px solid var(--theme-primary-border);
    }
  }
}

:global(.side-panel__hover-background):hover {
  border-radius: 6px;
  background-color: var(--theme-secondary-background);
}

.sidePanelFooter {
  border-top: 1px solid var(--theme-light-border);
  padding: var(--side-panel--content-padding);
}
